module.exports = __webpack_public_path__ + "img/bgc.a5ce1ef3.png";